module.exports = __webpack_public_path__ + "img/close-icon-dic.c98adf79.svg";